<template>

	<div class="col-12 mb-3 pt-3 pb-3 bg-white rounded border float-left">
		<div class="mt-2">
			<div class="form-group mt-3">
				<textarea type="text" rows="6" class="form-control" placeholder="متن پاسخ خود را اینجا بنویسید" v-model="textContent"></textarea>
			</div>
		</div>
		<div class="custom-file">
			<input type="file" class="custom-file-input" @change="filesChange" id="Files" multiple accept=".jpg,.jpeg,.png,.doc,.pdf,.rar,.zip,.xlsx,.docx" />
			<label style="padding-right:90px;" class="custom-file-label" for="Files">
				<small v-if="files.length > 0" class="pt-2">
					تعداد {{files.length}} فایل انتخاب شد
				</small>
				<small v-else>
					جهت انتخاب فایل اینجا کلیک نمایید
				</small>
			</label>
		</div>
		<div class="mt-2 d-block">
			<button @click="send" v-if="!isLoadingSend" class="btn btn-light btn-lg btn-block btn-lg">ارسال پاسخ</button>
			<button v-else disabled class="btn btn-light btn-lg btn-block btn-lg">درحال ارسال پاسخ. لطفا کمی صبر کنید ...</button>
		</div>
	</div>
</template>
<script>
	export default {

		emits:['reply'],
		props: {
			ticketId: {
				type:Number
			}
		},

		data()
		{
			return {
				isLoading: false,
				isLoadingSend: false,
				title: '',
				textContent: '',
				items: [],
				files: []
			};
		},

		beforeMount()
		{
		},

		methods:
		{
			async toDataUrl(file)
			{
				return new Promise((resolve, reject) =>
				{
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => resolve(reader.result);
					reader.onerror = error => reject(error);
				});
			},


			async send()
			{

				this.isLoadingSend = true;


				if (this.textContent == '')
				{
					this.$bvToast.toast('متن پاسخ خود را وارد نمایید', {
						title: 'خطا',
						toaster: 'b-toaster-top-center',
						variant: 'danger',
						bodyClass: 'text-center',
						noCloseButton: true,
						solid: true
					})

					this.isLoadingSend = false;
					return;
				}


				const payload = {
					title: this.title,
					ticketId: this.ticketId,
					textContent: this.textContent,
					docs: []
				}

				if (this.files.length > 0)
				{
					var size = 0;
					for (var i = 0; i < this.files.length; i++)
					{
						const file =
							this.files[i];

						payload.docs.push({
							fileName: file.name,
							base64: await this.toDataUrl(file)
						})

						size += file.size
					}

					if ((size / 1024 / 1024) > 20)
					{
						this.$bvToast.toast('حجم مجاز برای مجموع فایل های ارسالی حداکثر 20 مگابایت است', {
							title: 'خطا',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})

						this.isLoadingSend = false;
						return;
					}
				}

				const showSuccess = (trackingCode) =>
				{
					this.$bvToast.toast('تیکت با موفقیت ثبت شد', {
						title: 'عملیات موفق',
						toaster: 'b-toaster-top-center',
						variant: 'success',
						bodyClass: 'text-center',
						noCloseButton: true,
						solid: true
					})

					this.$emit('reply')
				}

				const showError = (message) =>
				{
					message =
						message ||
						'خطا در ارسال تیکت، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.';

					this.$bvToast.toast(message, {
						title: 'عملیات ناموفق',
						toaster: 'b-toaster-top-center',
						variant: 'danger',
						bodyClass: 'text-center',
						noCloseButton: true,
						solid: true
					})
				}

				axios({ method: "post", url: "/api/App/ReplyTicket", data: payload })
					.then(r =>
					{
						if (r.data.success)
						{
							showSuccess(r.data.meta.trackingCode)
						}
						else
						{
							showError(r.data.message)
						}

						this.isLoadingSend = false;
					})
					.catch(error =>
					{
						showError()

						this.isLoadingSend = false;
					});
			},

			filesChange(e)
			{
				this.files = e.target.files
			}
		}
	};
</script>
<style>
</style>
